import { DefaultTheme } from "styled-components";

export const lightTheme: DefaultTheme = {
  bgColor: "#2F2F2F",
  textColor: "white",
  accentColor: "#FCE49C",
  boardColor: "#f1f2f6",
  cardColor: "#ffffff",
  headerColor: "rgba(0, 0, 0, 0.5)",
  headertextColor: "white",
  footerColor: "#222",
};
